export default {
  eyebrow: 'Partnerportaal',
  title: 'Rekentool servicekosten',
  description: 'Schat de omzet uit servicekosten van alle restaurants onder uw partneraccount.',
  toasts: {
    load_error: 'Uw instellingen voor servicekosten konden niet worden geladen.',
  },
};
